import { z } from "zod";

export const baseSerieSchema = z.object({
  unit: z.literal("Wh").or(z.literal("%")).or(z.literal("€")),
  value: z.array(
    z.object({
      value: z.unknown(),
    }),
  ),
});

export type TBaseSerie = z.infer<typeof baseSerieSchema>;
